import { TransactionSide } from '../constants'

type OrderDetailsItemImageClickEventArgs = {
  screen?: string | null
  details?: string | null
  transactionId: string | null
  itemId: string
  positionInList: number
  itemsInList: number
  userSide: TransactionSide
}

export const orderDetailsItemImageClickEvent = (args: OrderDetailsItemImageClickEventArgs) => {
  const { details, transactionId, screen, userSide, itemId, positionInList, itemsInList } = args

  return {
    event: 'order_details_item_image.click',
    extra: {
      screen,
      transaction_id: transactionId,
      user_side: userSide,
      item_id: itemId,
      position_in_list: positionInList,
      items_in_list: itemsInList,
      details,
    },
  }
}
